
import httpClient from "@/plugins/axios";

export const getGroups = async () => {
    const response = await httpClient.get(`/admin/v1/groups/`);
    return response;
}

export const getGroup = async (groupId) => {
    const response = await httpClient.get(`/admin/v1/groups/${groupId}/?translations=1`);
    return response;
}

export const saveGroup = async (group) => {
    if (group.id) {
        return await updateGroup(group.id, group);
    }
    else {
        return await insertGroup(group);
    }
}

const insertGroup = async (formData) => {
    const response = await httpClient.post('/admin/v1/groups/', formData)
    return response;
}

const updateGroup = async (id, formData) => {
    const response = await httpClient.put(`/admin/v1/groups/${id}/`, formData)
    return response;
}

export const getGroupMembers = async (groupId, page, pageSize) => {
    const response = await httpClient.get(`/v1/tenant/groups/${groupId}/members/?admin_view=1&page=${page}&page_size=${pageSize}`);
    return response;
}

export const getGroupAdmins = async (groupId, page, pageSize) => {
    const response = await httpClient.get(`/v1/tenant/groups/${groupId}/admins/?admin_view=1&page=${page}&page_size=${pageSize}`);
    return response;
}
